import React, {Component,Fragment} from 'react';
import NotificationSystem from 'react-notification-system';
import moment from 'moment'
import {BeatLoader} from 'react-spinners';
import CatererDoughnut from '../../Caterer/Home/dashboard/doghnut';
import CatererOrderTrend from './dashboard/catrerOrderTrend';
import {  get } from '../../../server/actions';
import _ from 'lodash'
import MostOrdered from './dashboard/mostOrdered';
class Dashboard extends Component{
    constructor(props){
        super(props);
        this.state={
            schoolList:[],
            selectedSchoolId:this.props.selectSchool,
            mealType:this.props.mealType,
            selectedDate:moment(),
            loading:false,
            activeMonth:null,
            orderTrend:{
                data:{},
                currentYear:moment()
            },
            monthlyOrders:{
                data:{},
                selectedMonth: moment(),
            },
            mostOrdered:{
                data:{},
                selectedDates:{
                    startDate:moment().startOf('d'),
                    endDate:moment().endOf('d')
                },
            }
        }
    }
    componentWillMount=()=>{
        
    }
    componentDidMount=()=>{        
        this._notificationSystem = this.refs.notificationSystem;
        const schools= (JSON.parse(sessionStorage.getItem('loggedInUserDetails'))||{}).schools||[];
        const sid=schools.length>0?schools[0].schoolId:0
        this.setState({schoolList:schools,selectedSchool:sid});
        this.orderTrend();
        this.monthlySchoolOrders();
        this.mostOrdered();
    }
    componentWillReceiveProps=(nextProps)=>{
        this.setState({selectedSchoolId:nextProps.selectSchool, mealType:nextProps.mealType},()=>{
            this.orderTrend();
            this.monthlySchoolOrders();
            this.mostOrdered();
        })
    }
    orderTrend=()=>{
        const catId= this.state.selectedSchoolId==0?sessionStorage.getItem('catererId'):this.state.selectedSchoolId;
        const isCaterer=this.state.selectedSchoolId==0?true:false;
        const dateStart=this.state.orderTrend.currentYear.startOf('y').format('YYYYMM');
        const dateEnd=this.state.orderTrend.currentYear.endOf('y').format('YYYYMM');
        get(`/dashboard/ordersCountByMonth?mealSchoolId=${catId}&isCaterer=${isCaterer}&menuType=${this.props.mealType}&yearMonthStart=${dateStart}&yearMonthEnd=${dateEnd}&access_token=`)
       .then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _orderTrend=this.state.orderTrend;
            _orderTrend.data=orders;
            this.setState({ orderTrend:_orderTrend,loading: false})            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
    }
    mostOrdered=(_startDate,_endDate)=>{
        const catId= this.state.selectedSchoolId==0?sessionStorage.getItem('catererId'):this.state.selectedSchoolId;
        const isCaterer=this.state.selectedSchoolId==0?true:false;
        const dateStart=this.state.mostOrdered.selectedDates.startDate.startOf('d').format('YYYY-MM-DD');
        const dateEnd=this.state.mostOrdered.selectedDates.endDate.endOf('d').format('YYYY-MM-DD');
        get(`/dashboard/nMostOrderedItems?mealSchoolId=${catId}&isCaterer=${isCaterer}&menuType=${this.props.mealType}&startDate=${dateStart}&endDate=${dateEnd}&requiredTopItems=5&access_token=`)
       .then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _mostOrdered=this.state.mostOrdered;
            _mostOrdered.data=orders;
            this.setState({ mostOrdered:_mostOrdered,loading: false})            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
    }
    monthlySchoolOrders=()=>{
        this.setState({loading: true});
        let selectedMonthYear=this.state.monthlyOrders.selectedMonth.format('YYYYMM');
        const url=this.state.selectedSchoolId==0?
        `/reports/countBySchool?catererId=${sessionStorage.getItem('catererId')}&isCaterer=true&yearMonth=${selectedMonthYear}&menuType=${this.props.mealType}&access_token=`:
        `/reports/countBySchool?catererId=${this.state.selectedSchoolId}&yearMonth=${selectedMonthYear}&menuType=${this.props.mealType}&access_token=`;
       get(url).then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _monthlyOrders=this.state.monthlyOrders;
            _monthlyOrders.data=orders;
            this.setState({ monthlyOrders:_monthlyOrders,loading: false})       
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
    }
    render(){
        return(<Fragment>
         <section className="full-width clearfix">              
            <NotificationSystem ref="notificationSystem"/>  
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>           
            <div className="container">
                {/* <div className="sectionTitle" style={{paddingBottom:'10px'}}>                        
                    <div className="row ">
                        <div className="col-xs-12">
                            <div className="pull-right" style={{display:'block'}}>
                            <Datetime 
                                ref='calendar' 
                                value={this.state.selectedDate}
                                dateFormat="MM-DD-YYYY"
                                input={true}
                                timeFormat={false}
                                closeOnSelect={true}
                                isValidDate={(currentDate)=>{
                                // let minDate=moment();
                                    //minDate.set({hour:0,minute:0,second:0,millisecond:0})
                                // currentDate.set({hour:0,minute:0,second:0,millisecond:0})
                                //  return (minDate<currentDate) ;
                                return true;
                                }}
                                renderInput={(props, openCalendar, closeCalendar) => {
                                    return (
                                        <h5><label onClick={openCalendar}>                                                
                                            {moment(this.state.selectedDate).format('MM-DD-YYYY')+'  ' } 
                                            <i className="fa fa-calendar" aria-hidden="true"></i>                                                                        
                                        </label></h5>
                                    );
                                }}                           
                                onChange={(e)=>{
                                    this.setState({selectedDate:e});
                                }} /></div>
                            </div>
                        </div>  </div> */}
                    <div className="row">                      
                            <CatererDoughnut {...this.props} data={this.state.monthlyOrders} onChangeMonth={(date)=>{
                                let _monthlyOrders=this.state.monthlyOrders;
                                _monthlyOrders.selectedMonth=date;
                                this.setState({ monthlyOrders:_monthlyOrders,loading: false},()=>{
                                    this.monthlySchoolOrders()
                                })
                            }}  />
                            <CatererOrderTrend {...this.props} data={this.state.orderTrend} onChangeYear={(action)=>{
                                const _orderTrend=this.state.orderTrend;
                                if(action=='ADD'){
                                    _orderTrend.currentYear=_orderTrend.currentYear.add(1,'y');
                                }else if(action=='SUB'){
                                    _orderTrend.currentYear=_orderTrend.currentYear.subtract(1,'y');
                                }else{
                                    _orderTrend.currentYear=moment();
                                }
                                this.setState({orderTrend:_orderTrend},()=>{
                                    this.orderTrend()
                                })
                            }} />   
                            <MostOrdered {...this.props} data={this.state.mostOrdered}
                             onChangeDateRange={(start,end)=>{
                                const _mostOrdered=this.state.mostOrdered;
                                _mostOrdered.selectedDates.startDate=start;
                                _mostOrdered.selectedDates.endDate=end;
                             this.setState({mostOrdered:_mostOrdered,loading: false},()=>{
                             this.mostOrdered();
                                }) 
                            }} />
                        </div>
                </div>
            </section>
        </Fragment>)
    }
}
export default Dashboard


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/Dashboard.jsx